import React, { useState } from "react";
import { Accordion, Card, Row } from "react-bootstrap";
import renderHtml from "react-render-html";
import { FiPlus } from "react-icons/fi";

const ExpandableBox = ({ data }) => {
  const [activeItem, setActiveItem] = useState(null);
  const handleToggle = key => {
    setActiveItem(activeItem === key ? null : key);
  };

  return (
    <Accordion style={{ padding: "10px 0" }}>
      {data
        ? data.map(collapse => (
            <Row
              style={{ padding: "0" }}
              key={collapse.title}
              id={collapse.title}>
              <div className="faq-q-container">
                <Accordion.Toggle
                  as={Row}
                  variant="link"
                  eventKey={collapse.title}
                  onClick={() => handleToggle(collapse.title)}>
                  <div className="faq-q-content">
                    {collapse.title}
                    <FiPlus
                      className="faq-q-icon"
                      style={{
                        transition: "transform 0.3s ease",
                        transform:
                          activeItem === collapse.title
                            ? "rotate(-45deg)"
                            : "rotate(0deg)",
                      }}
                    />
                  </div>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={collapse.title}>
                  <Card.Body className="text-justify">
                    {renderHtml(collapse.body)}
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </Row>
          ))
        : ""}
    </Accordion>
  );
};

export default ExpandableBox;
